<div class="horizontalMenucontainer">
  <div class="page custom-index">
    <!-- // header -->
    <app-header></app-header>
    <!-- //sidebar -->
    <app-sidebar appHoverEffectSidebar></app-sidebar>
    <div class="main-content app-content">
      <div class="main-container container-fluid">
        <!-- // contetnt  -->
        <router-outlet>
          <app-loader></app-loader>
        </router-outlet>
      </div>
    </div>
  </div>
  <!-- right sidebar -->
  <app-right-sidebar></app-right-sidebar>
  <!-- footer  -->
  <app-footer></app-footer>
</div>
<app-tab-to-top></app-tab-to-top>
